import styled from 'styled-components';

export const ChatWrapper = styled.div`
  .chat_container {
    height: calc(100vh - 15.4rem);

    .list_messages {
      height: calc(100vh - 15.4rem);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Chat/components/styles.js